import React, { lazy, Suspense, useMemo } from "react";
import type { MarkdownProps } from "./Markdown.types";
import "./Markdown.scss";
import { Loading } from "../Base";

// 懒加载 MarkdownPreview 组件
const MarkdownPreview = lazy(() => import("@uiw/react-markdown-preview"));

// 自定义 table 组件，包裹在可滚动容器中
const TableWrapper: React.FC<React.HTMLAttributes<HTMLTableElement>> = ({
  children,
  ...props
}) => (
  <div className="table-scroll-wrapper">
    <table {...props}>{children}</table>
  </div>
);

export const Markdown: React.FC<MarkdownProps> = ({
  source,
  className = "",
  style,
}) => {
  // 自定义渲染组件
  const components = useMemo(
    () => ({
      table: TableWrapper,
    }),
    []
  );

  if (!source) {
    return null;
  }

  return (
    <div className={`markdown-content ${className}`} style={style}>
      <Suspense fallback={<Loading />}>
        <MarkdownPreview
          source={source}
          style={{
            background: "transparent",
            color: "inherit",
          }}
          components={components}
        />
      </Suspense>
    </div>
  );
};

export default Markdown;
